module.exports = __webpack_public_path__ + "media/images/map-marker-0a5994d5b0b41c1d5dea08dbcd785668.png";